module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-11-13",
		"endpointPrefix": "ecs",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "Amazon ECS",
		"serviceFullName": "Amazon EC2 Container Service",
		"signatureVersion": "v4",
		"targetPrefix": "AmazonEC2ContainerServiceV20141113"
	},
	"operations": {
		"CreateCluster": {
			"input": {
				"type": "structure",
				"members": {
					"clusterName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"cluster": {
						"shape": "S4"
					}
				}
			}
		},
		"CreateService": {
			"input": {
				"type": "structure",
				"required": [
					"serviceName",
					"taskDefinition",
					"desiredCount"
				],
				"members": {
					"cluster": {},
					"serviceName": {},
					"taskDefinition": {},
					"loadBalancers": {
						"shape": "S7"
					},
					"desiredCount": {
						"type": "integer"
					},
					"clientToken": {},
					"role": {},
					"deploymentConfiguration": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"service": {
						"shape": "Sc"
					}
				}
			}
		},
		"DeleteCluster": {
			"input": {
				"type": "structure",
				"required": [
					"cluster"
				],
				"members": {
					"cluster": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"cluster": {
						"shape": "S4"
					}
				}
			}
		},
		"DeleteService": {
			"input": {
				"type": "structure",
				"required": [
					"service"
				],
				"members": {
					"cluster": {},
					"service": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"service": {
						"shape": "Sc"
					}
				}
			}
		},
		"DeregisterContainerInstance": {
			"input": {
				"type": "structure",
				"required": [
					"containerInstance"
				],
				"members": {
					"cluster": {},
					"containerInstance": {},
					"force": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"containerInstance": {
						"shape": "Sp"
					}
				}
			}
		},
		"DeregisterTaskDefinition": {
			"input": {
				"type": "structure",
				"required": [
					"taskDefinition"
				],
				"members": {
					"taskDefinition": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"taskDefinition": {
						"shape": "S12"
					}
				}
			}
		},
		"DescribeClusters": {
			"input": {
				"type": "structure",
				"members": {
					"clusters": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"clusters": {
						"type": "list",
						"member": {
							"shape": "S4"
						}
					},
					"failures": {
						"shape": "S1w"
					}
				}
			}
		},
		"DescribeContainerInstances": {
			"input": {
				"type": "structure",
				"required": [
					"containerInstances"
				],
				"members": {
					"cluster": {},
					"containerInstances": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"containerInstances": {
						"type": "list",
						"member": {
							"shape": "Sp"
						}
					},
					"failures": {
						"shape": "S1w"
					}
				}
			}
		},
		"DescribeServices": {
			"input": {
				"type": "structure",
				"required": [
					"services"
				],
				"members": {
					"cluster": {},
					"services": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"services": {
						"type": "list",
						"member": {
							"shape": "Sc"
						}
					},
					"failures": {
						"shape": "S1w"
					}
				}
			}
		},
		"DescribeTaskDefinition": {
			"input": {
				"type": "structure",
				"required": [
					"taskDefinition"
				],
				"members": {
					"taskDefinition": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"taskDefinition": {
						"shape": "S12"
					}
				}
			}
		},
		"DescribeTasks": {
			"input": {
				"type": "structure",
				"required": [
					"tasks"
				],
				"members": {
					"cluster": {},
					"tasks": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"tasks": {
						"shape": "S28"
					},
					"failures": {
						"shape": "S1w"
					}
				}
			}
		},
		"DiscoverPollEndpoint": {
			"input": {
				"type": "structure",
				"members": {
					"containerInstance": {},
					"cluster": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"endpoint": {},
					"telemetryEndpoint": {}
				}
			}
		},
		"ListClusters": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"clusterArns": {
						"shape": "Sv"
					},
					"nextToken": {}
				}
			}
		},
		"ListContainerInstances": {
			"input": {
				"type": "structure",
				"members": {
					"cluster": {},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"containerInstanceArns": {
						"shape": "Sv"
					},
					"nextToken": {}
				}
			}
		},
		"ListServices": {
			"input": {
				"type": "structure",
				"members": {
					"cluster": {},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"serviceArns": {
						"shape": "Sv"
					},
					"nextToken": {}
				}
			}
		},
		"ListTaskDefinitionFamilies": {
			"input": {
				"type": "structure",
				"members": {
					"familyPrefix": {},
					"status": {},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"families": {
						"shape": "Sv"
					},
					"nextToken": {}
				}
			}
		},
		"ListTaskDefinitions": {
			"input": {
				"type": "structure",
				"members": {
					"familyPrefix": {},
					"status": {},
					"sort": {},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"taskDefinitionArns": {
						"shape": "Sv"
					},
					"nextToken": {}
				}
			}
		},
		"ListTasks": {
			"input": {
				"type": "structure",
				"members": {
					"cluster": {},
					"containerInstance": {},
					"family": {},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					},
					"startedBy": {},
					"serviceName": {},
					"desiredStatus": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"taskArns": {
						"shape": "Sv"
					},
					"nextToken": {}
				}
			}
		},
		"RegisterContainerInstance": {
			"input": {
				"type": "structure",
				"members": {
					"cluster": {},
					"instanceIdentityDocument": {},
					"instanceIdentityDocumentSignature": {},
					"totalResources": {
						"shape": "Ss"
					},
					"versionInfo": {
						"shape": "Sr"
					},
					"containerInstanceArn": {},
					"attributes": {
						"shape": "Sy"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"containerInstance": {
						"shape": "Sp"
					}
				}
			}
		},
		"RegisterTaskDefinition": {
			"input": {
				"type": "structure",
				"required": [
					"family",
					"containerDefinitions"
				],
				"members": {
					"family": {},
					"taskRoleArn": {},
					"networkMode": {},
					"containerDefinitions": {
						"shape": "S13"
					},
					"volumes": {
						"shape": "S1o"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"taskDefinition": {
						"shape": "S12"
					}
				}
			}
		},
		"RunTask": {
			"input": {
				"type": "structure",
				"required": [
					"taskDefinition"
				],
				"members": {
					"cluster": {},
					"taskDefinition": {},
					"overrides": {
						"shape": "S2a"
					},
					"count": {
						"type": "integer"
					},
					"startedBy": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"tasks": {
						"shape": "S28"
					},
					"failures": {
						"shape": "S1w"
					}
				}
			}
		},
		"StartTask": {
			"input": {
				"type": "structure",
				"required": [
					"taskDefinition",
					"containerInstances"
				],
				"members": {
					"cluster": {},
					"taskDefinition": {},
					"overrides": {
						"shape": "S2a"
					},
					"containerInstances": {
						"shape": "Sv"
					},
					"startedBy": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"tasks": {
						"shape": "S28"
					},
					"failures": {
						"shape": "S1w"
					}
				}
			}
		},
		"StopTask": {
			"input": {
				"type": "structure",
				"required": [
					"task"
				],
				"members": {
					"cluster": {},
					"task": {},
					"reason": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"task": {
						"shape": "S29"
					}
				}
			}
		},
		"SubmitContainerStateChange": {
			"input": {
				"type": "structure",
				"members": {
					"cluster": {},
					"task": {},
					"containerName": {},
					"status": {},
					"exitCode": {
						"type": "integer"
					},
					"reason": {},
					"networkBindings": {
						"shape": "S2f"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"acknowledgment": {}
				}
			}
		},
		"SubmitTaskStateChange": {
			"input": {
				"type": "structure",
				"members": {
					"cluster": {},
					"task": {},
					"status": {},
					"reason": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"acknowledgment": {}
				}
			}
		},
		"UpdateContainerAgent": {
			"input": {
				"type": "structure",
				"required": [
					"containerInstance"
				],
				"members": {
					"cluster": {},
					"containerInstance": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"containerInstance": {
						"shape": "Sp"
					}
				}
			}
		},
		"UpdateService": {
			"input": {
				"type": "structure",
				"required": [
					"service"
				],
				"members": {
					"cluster": {},
					"service": {},
					"desiredCount": {
						"type": "integer"
					},
					"taskDefinition": {},
					"deploymentConfiguration": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"service": {
						"shape": "Sc"
					}
				}
			}
		}
	},
	"shapes": {
		"S4": {
			"type": "structure",
			"members": {
				"clusterArn": {},
				"clusterName": {},
				"status": {},
				"registeredContainerInstancesCount": {
					"type": "integer"
				},
				"runningTasksCount": {
					"type": "integer"
				},
				"pendingTasksCount": {
					"type": "integer"
				},
				"activeServicesCount": {
					"type": "integer"
				}
			}
		},
		"S7": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"targetGroupArn": {},
					"loadBalancerName": {},
					"containerName": {},
					"containerPort": {
						"type": "integer"
					}
				}
			}
		},
		"Sa": {
			"type": "structure",
			"members": {
				"maximumPercent": {
					"type": "integer"
				},
				"minimumHealthyPercent": {
					"type": "integer"
				}
			}
		},
		"Sc": {
			"type": "structure",
			"members": {
				"serviceArn": {},
				"serviceName": {},
				"clusterArn": {},
				"loadBalancers": {
					"shape": "S7"
				},
				"status": {},
				"desiredCount": {
					"type": "integer"
				},
				"runningCount": {
					"type": "integer"
				},
				"pendingCount": {
					"type": "integer"
				},
				"taskDefinition": {},
				"deploymentConfiguration": {
					"shape": "Sa"
				},
				"deployments": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"id": {},
							"status": {},
							"taskDefinition": {},
							"desiredCount": {
								"type": "integer"
							},
							"pendingCount": {
								"type": "integer"
							},
							"runningCount": {
								"type": "integer"
							},
							"createdAt": {
								"type": "timestamp"
							},
							"updatedAt": {
								"type": "timestamp"
							}
						}
					}
				},
				"roleArn": {},
				"events": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"id": {},
							"createdAt": {
								"type": "timestamp"
							},
							"message": {}
						}
					}
				},
				"createdAt": {
					"type": "timestamp"
				}
			}
		},
		"Sp": {
			"type": "structure",
			"members": {
				"containerInstanceArn": {},
				"ec2InstanceId": {},
				"version": {
					"type": "long"
				},
				"versionInfo": {
					"shape": "Sr"
				},
				"remainingResources": {
					"shape": "Ss"
				},
				"registeredResources": {
					"shape": "Ss"
				},
				"status": {},
				"agentConnected": {
					"type": "boolean"
				},
				"runningTasksCount": {
					"type": "integer"
				},
				"pendingTasksCount": {
					"type": "integer"
				},
				"agentUpdateStatus": {},
				"attributes": {
					"shape": "Sy"
				}
			}
		},
		"Sr": {
			"type": "structure",
			"members": {
				"agentVersion": {},
				"agentHash": {},
				"dockerVersion": {}
			}
		},
		"Ss": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"name": {},
					"type": {},
					"doubleValue": {
						"type": "double"
					},
					"longValue": {
						"type": "long"
					},
					"integerValue": {
						"type": "integer"
					},
					"stringSetValue": {
						"shape": "Sv"
					}
				}
			}
		},
		"Sv": {
			"type": "list",
			"member": {}
		},
		"Sy": {
			"type": "list",
			"member": {
				"shape": "Sz"
			}
		},
		"Sz": {
			"type": "structure",
			"required": [
				"name"
			],
			"members": {
				"name": {},
				"value": {}
			}
		},
		"S12": {
			"type": "structure",
			"members": {
				"taskDefinitionArn": {},
				"containerDefinitions": {
					"shape": "S13"
				},
				"family": {},
				"taskRoleArn": {},
				"networkMode": {},
				"revision": {
					"type": "integer"
				},
				"volumes": {
					"shape": "S1o"
				},
				"status": {},
				"requiresAttributes": {
					"type": "list",
					"member": {
						"shape": "Sz"
					}
				}
			}
		},
		"S13": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"name": {},
					"image": {},
					"cpu": {
						"type": "integer"
					},
					"memory": {
						"type": "integer"
					},
					"memoryReservation": {
						"type": "integer"
					},
					"links": {
						"shape": "Sv"
					},
					"portMappings": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"containerPort": {
									"type": "integer"
								},
								"hostPort": {
									"type": "integer"
								},
								"protocol": {}
							}
						}
					},
					"essential": {
						"type": "boolean"
					},
					"entryPoint": {
						"shape": "Sv"
					},
					"command": {
						"shape": "Sv"
					},
					"environment": {
						"shape": "S18"
					},
					"mountPoints": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"sourceVolume": {},
								"containerPath": {},
								"readOnly": {
									"type": "boolean"
								}
							}
						}
					},
					"volumesFrom": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"sourceContainer": {},
								"readOnly": {
									"type": "boolean"
								}
							}
						}
					},
					"hostname": {},
					"user": {},
					"workingDirectory": {},
					"disableNetworking": {
						"type": "boolean"
					},
					"privileged": {
						"type": "boolean"
					},
					"readonlyRootFilesystem": {
						"type": "boolean"
					},
					"dnsServers": {
						"shape": "Sv"
					},
					"dnsSearchDomains": {
						"shape": "Sv"
					},
					"extraHosts": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"hostname",
								"ipAddress"
							],
							"members": {
								"hostname": {},
								"ipAddress": {}
							}
						}
					},
					"dockerSecurityOptions": {
						"shape": "Sv"
					},
					"dockerLabels": {
						"type": "map",
						"key": {},
						"value": {}
					},
					"ulimits": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"name",
								"softLimit",
								"hardLimit"
							],
							"members": {
								"name": {},
								"softLimit": {
									"type": "integer"
								},
								"hardLimit": {
									"type": "integer"
								}
							}
						}
					},
					"logConfiguration": {
						"type": "structure",
						"required": [
							"logDriver"
						],
						"members": {
							"logDriver": {},
							"options": {
								"type": "map",
								"key": {},
								"value": {}
							}
						}
					}
				}
			}
		},
		"S18": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"name": {},
					"value": {}
				}
			}
		},
		"S1o": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"name": {},
					"host": {
						"type": "structure",
						"members": {
							"sourcePath": {}
						}
					}
				}
			}
		},
		"S1w": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"arn": {},
					"reason": {}
				}
			}
		},
		"S28": {
			"type": "list",
			"member": {
				"shape": "S29"
			}
		},
		"S29": {
			"type": "structure",
			"members": {
				"taskArn": {},
				"clusterArn": {},
				"taskDefinitionArn": {},
				"containerInstanceArn": {},
				"overrides": {
					"shape": "S2a"
				},
				"lastStatus": {},
				"desiredStatus": {},
				"containers": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"containerArn": {},
							"taskArn": {},
							"name": {},
							"lastStatus": {},
							"exitCode": {
								"type": "integer"
							},
							"reason": {},
							"networkBindings": {
								"shape": "S2f"
							}
						}
					}
				},
				"startedBy": {},
				"version": {
					"type": "long"
				},
				"stoppedReason": {},
				"createdAt": {
					"type": "timestamp"
				},
				"startedAt": {
					"type": "timestamp"
				},
				"stoppedAt": {
					"type": "timestamp"
				}
			}
		},
		"S2a": {
			"type": "structure",
			"members": {
				"containerOverrides": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"name": {},
							"command": {
								"shape": "Sv"
							},
							"environment": {
								"shape": "S18"
							}
						}
					}
				},
				"taskRoleArn": {}
			}
		},
		"S2f": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"bindIP": {},
					"containerPort": {
						"type": "integer"
					},
					"hostPort": {
						"type": "integer"
					},
					"protocol": {}
				}
			}
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/aws-sdk/apis/ecs-2014-11-13.min.json
 ** module id = 1297
 ** module chunks = 0
 **/